/**
 * MypageRecentlySawContainer
 * --
 */
import React from 'react';
import MypageRecentlySawPresenter from './MypageRecentlySawPresenter';

const MypageRecentlySawContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MypageRecentlySawPresenter screenSize={screenSize} />
    </>
  );
};

export default MypageRecentlySawContainer;
